import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth.service';

import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { map, startWith } from 'rxjs';



@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent {
  year = new Date().getFullYear();

  currentLang$: any;
  
  isProd = environment.env === 'prod';
  isDev = environment.env === 'dev';
  isStage = environment.env === 'stage';

  constructor(
    private translateService: TranslateService,
    private auth: AuthService,
    private router: Router
  ) {
    if (this.auth.isLoggedIn) {
      this.router.navigate(['/'])
    }

    this.currentLang$ = this.translateService.onLangChange.asObservable().pipe(
      startWith(''),
      map(() => this.translateService.currentLang),
    );
  }
  changeLang(lang: string = 'en') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.setLocale(lang);
    this.translateService.use(lang);
  }

  ngAfterViewInit() {
    const loader = document.getElementById("globalLoader");    
    loader?.classList.add("hidden");
  }
}
